import React, {Component} from 'react';
import {
    ArrayInput,
    BooleanInput,
    Confirm,
    FileInput,
    FormDataConsumer,
    LongTextInput,
    NumberInput,
    required,
    SaveButton,
    SelectArrayInput,
    SelectInput,
    SimpleForm,
    SimpleFormIterator,
    TextInput,
    Toolbar,
    translate
} from 'react-admin';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {change, submit} from 'redux-form';
import Button from '@material-ui/core/Button';
import {withRouter} from 'react-router-dom';
import RichTextInput from 'ra-input-rich-text';

import {isRequired} from '~utils/inputValidations';
import FieldGroup from '~components/FieldGroup';
import FileLinkField from '~components/FileLinkField';
import GalleryItemsInput from '~components/GalleryItemsInput';
import {LeaveGuardContext} from '~components/Breadcrumbs';
import {IirsaCountriesService} from '~config/services/iirsa_countries.service';
import {can, countryScope, DELETE_DRAFT, DELETE_PROYECTO, readPermissions} from '~utils/permissions';
import {RoutesService} from '~config/services/routes.service';
import {CodesService} from '~config/services/codes.service';
import {EstadosService} from '~config/services/estados.service';
import {EtapasService} from '~config/services/etapas.service';
import {AlcancesService} from '~config/services/alcances.service';
import {EstadosEstudiosService} from '~config/services/estados_estudios.service';
import {FinanciadoresEstudiosService} from '~config/services/financiadores_estudios.service';
import {TiposFinanciamientoService} from '~config/services/tipos_financiamiento.service';
import {EstadosFinanciamientoService} from '~config/services/estados_financiamiento.service';
import {TiposProyectoService} from '~config/services/tipos_proyecto.service';
import {PriorizacionesService} from '../../../../config/services/priorizaciones.service';

import DynamicMap from '../components/DynamicMap';
import './styles.scss';
import NestedSelectInput from '../components/NestedSelectInput';

import styles from './styles';
import {SectorsService} from "../../../../config/services/sectors.service";

const VolverButton = props => (<>
        <Button style={styles.volverButton} onClick={props.onVolverClick}>
            <svg style={styles.chevron} viewBox="0 0 32 32" class="icon icon-chevron-left">
                <path
                    fill="#3f51b5"
                    d="M14.19 16.005l7.869 7.868-2.129 2.129-9.996-9.997L19.937 6.002l2.127 2.129z"
                />
            </svg>
            Volver
        </Button>
        <Confirm
            isOpen={props.showConfirm}
            title="¿Desea salir del formulario?"
            content="Los cambios realizados se perderán"
            confirm="Si"
            confirmColor="primary"
            cancel="Cancelar"
            onConfirm={props.onVolverConfirm}
            onClose={props.onVolverCancel}
        />
    </>);

const toolbarOptions = [['bold', 'italic', 'underline', 'link'], [{list: 'bullet'}]];

// react-admin's default form toolbar always renders Delete on edit. Users without the
// delete permission (country managers) get Save only; everyone else keeps the default.
const SaveOnlyToolbar = props => (
    <Toolbar {...props}>
        <SaveButton/>
    </Toolbar>
);

class IirsaProjectForm extends Component {
    state = {
        countries: [],
        routes: [],
        codes: [],
        sectors: [],
        estadosChoices: [],
        etapasChoices: [],
        alcancesChoices: [],
        estadosEstudiosChoices: [],
        financiadoresEstudiosChoices: [],
        tiposFinanciamientoChoices: [],
        estadosFinanciamientoChoices: [],
        tiposProyectoChoices: [],
        priorizacionesChoices: [],
        showConfirm: false
    };

    firstForm = null;
    hasChanged = false;

    constructor() {
        super();

        const cs = new IirsaCountriesService();
        cs.get_la().then(r => {
            let data = r.data;
            data.sort((a, b) => (a.name > b.name ? 1 : -1));
            this.setState({...this.state, countries: data});
        });

        const rs = new RoutesService();
        rs.get().then(r => {
            let data = r.data;
            data.sort((a, b) => (a.name > b.name ? 1 : -1));
            this.setState({...this.state, routes: data});
        });

        const codesService = new CodesService();
        codesService.get().then(r => {
            let data = r.data;
            this.setState({...this.state, codes: data});
        });

        const sectorsService = new SectorsService();
        sectorsService.get().then(r => {
            this.setState({...this.state, sectors: r.data});
        });

        const estadosService = new EstadosService();
        estadosService.get().then(r => {
            let data = r.data;
            data.sort((a, b) => (a.name > b.name ? 1 : -1));
            this.setState({...this.state, estadosChoices: data});
        });

        const etapasService = new EtapasService();
        etapasService.get().then(r => {
            let data = r.data;
            data.sort((a, b) => (a.name > b.name ? 1 : -1));
            this.setState({...this.state, etapasChoices: data});
        });

        const alcancesService = new AlcancesService();
        alcancesService.get().then(r => {
            let data = r.data;
            data.sort((a, b) => (a.name > b.name ? 1 : -1));
            this.setState({...this.state, alcancesChoices: data});
        });

        const estadosEstudiosService = new EstadosEstudiosService();
        estadosEstudiosService.get().then(r => {
            let data = r.data;
            data.sort((a, b) => (a.name > b.name ? 1 : -1));
            this.setState({...this.state, estadosEstudiosChoices: data});
        });

        const financiadoresEstudiosService = new FinanciadoresEstudiosService();
        financiadoresEstudiosService.get().then(r => {
            let data = r.data;
            data.sort((a, b) => (a.name > b.name ? 1 : -1));
            this.setState({...this.state, financiadoresEstudiosChoices: data});
        });

        const tiposFinanciamientoService = new TiposFinanciamientoService();
        tiposFinanciamientoService.get().then(r => {
            let data = r.data;
            data.sort((a, b) => (a.name > b.name ? 1 : -1));
            this.setState({...this.state, tiposFinanciamientoChoices: data});
        });

        const estadosFinanciamientoService = new EstadosFinanciamientoService();
        estadosFinanciamientoService.get().then(r => {
            let data = r.data;
            data.sort((a, b) => (a.name > b.name ? 1 : -1));
            this.setState({...this.state, estadosFinanciamientoChoices: data});
        });

        const tiposProyectoService = new TiposProyectoService();
        tiposProyectoService.get().then(r => {
            let data = r.data;
            data.sort((a, b) => (a.name > b.name ? 1 : -1));
            this.setState({...this.state, tiposProyectoChoices: data});
        });

        const priorizacionesService = new PriorizacionesService();
        priorizacionesService.get().then(r => {
            let data = r.data.page || r.data;  // Handle paginated response
            data.sort((a, b) => (a.name > b.name ? 1 : -1));
            this.setState({...this.state, priorizacionesChoices: data});
        });
    }

    // Draft mode relaxes every required-field validator: a draft may be saved
    // incomplete. Provided values are still validated by the inputs/serializer.
    get isDraft() {
        return !!this.props.draft;
    }

    hasTracking() {
        return !this.isDraft && !!(this.props.record && this.props.record.has_tracking);
    }

    // `locked` when the user's project writes are restricted to their own countries.
    get countryScope() {
        return countryScope();
    }

    // The form is shared by projects and drafts, which have separate delete rights.
    get canDelete() {
        return can(readPermissions(), this.isDraft ? DELETE_DRAFT : DELETE_PROYECTO);
    }

    // `isRequired` normally; no validator in draft mode.
    get req() {
        return this.isDraft ? undefined : isRequired;
    }

    // `[required(msg)]` normally; empty (no validator) in draft mode.
    reqMap(msg) {
        return this.isDraft ? [] : [required(msg)];
    }

    // code validators: [isRequired, codeIsUnique] normally; none in draft mode.
    get reqCode() {
        return this.isDraft ? undefined : [isRequired, this.codeIsUnique];
    }

    codeIsUnique = (value, allValues, {translate}) => {
        if (this.state.codes?.indexOf(value) > -1) {
            return 'Este código ya se encuentra en uso';
        }
        return undefined;
    }

    validateProjectForm = values => {
        const errors = {};
        if (!this.isDraft && (!values.iirsa_countries || values.iirsa_countries.length == 0)) {
            errors.iirsa_countries = ['Debe seleccionar al menos un país'];
        }
        if (values['slug'] && this.state.slugs?.indexOf(values.slug) > -1) {
            errors.slug = 'Este slug ya se encuentra en uso';
        }
        if (values['image'] && values['image'].rawFile && values['image'].rawFile.size > 15000000) {
            errors.image = 'El tamaño de la imagen no puede ser mayor a 15MB';
        }
        return errors;
    };

    get listPath() {
        return this.isDraft ? '/draft-projects' : '/projects';
    }

    static contextType = LeaveGuardContext;

    componentDidMount() {
        this.context.current = this.requestLeave;
    }

    componentWillUnmount() {
        if (this.context.current === this.requestLeave) this.context.current = null;
    }

    // Shared by Volver and the breadcrumb links: confirm first if the form has changes.
    requestLeave = path => {
        if (this.hasChanged) {
            this.setState({showConfirm: true, pendingPath: path});
        } else {
            this.props.history.push(path);
        }
    };

    onVolverClick = () => this.requestLeave(this.listPath);

    onVolverConfirm = () => {
        this.props.history.push(this.state.pendingPath);
    };

    onVolverCancel = () => {
        this.setState({showConfirm: false});
    };

    isCreateForm() {
        return this.props.location?.pathname.endsWith('/create');
    }

    render() {
        return (<>
                <VolverButton
                    showConfirm={this.state.showConfirm}
                    onVolverClick={this.onVolverClick}
                    onVolverConfirm={this.onVolverConfirm}
                    onVolverCancel={this.onVolverCancel}
                />
                {/* `undefined` keeps SimpleForm's default toolbar (Save + Delete). */}
                <SimpleForm
                    validate={this.validateProjectForm}
                    toolbar={this.canDelete ? undefined : <SaveOnlyToolbar/>}
                    {...this.props}
                >
                    {this.children}

                    <FormDataConsumer>
                        {data => {
                            if (!this.firstForm) {
                                this.firstForm = data;
                            } else {
                                if (!(JSON.stringify(data) === JSON.stringify(this.firstForm))) {
                                    this.hasChanged = true;
                                }
                            }

                            if (data && data.formData && data.formData.end_date) {
                                data.formData.end_date = data.formData.end_date.substring(0, 7);
                            }
                        }}
                    </FormDataConsumer>

                    <FieldGroup
                        label="fieldGroups.projectInformation"
                        formClassName={this.props.classes.borderBottom}
                        titleColumn={false}
                        flex={false}
                    >
                        <SelectInput source="route" choices={this.state.routes} validate={this.req}
                                     className={'colInput'} label={'Agrupación de proyectos (*)'}/>
                        <TextInput source="name" validate={this.req} className={'colInput'}/>
                        {(this.isCreateForm() || this.isDraft) ? <TextInput source="code" validate={this.reqCode}
                                                          className={'colInput'}/> :
                            <TextInput source="code" className={'colInput'} disabled/>}
                    </FieldGroup>

                    <FieldGroup
                        label="fieldGroups.scope"
                        formClassName={this.props.classes.borderBottom}
                        titleColumn={false}
                        flex={false}
                    >
                        <div className={'colInputContainer'}>
                            <label style={styles.inputLabel}>Objetivos (*)</label>
                            <RichTextInput source="goal" toolbar={toolbarOptions} validate={this.req}/>
                        </div>
                        <div className={'colInputContainer'}>
                            <label style={styles.inputLabel}>Descripción (*)</label>
                            <RichTextInput source="description" toolbar={toolbarOptions} validate={this.req}/>
                        </div>
                    </FieldGroup>

                    <FieldGroup
                        label="fieldGroups.ilat"
                        formClassName={this.props.classes.borderBottom}
                        titleColumn={false}
                        flex={false}
                    >
                        <BooleanInput source="is_portfolio" className={'colInputContainer'}/>
                        <BooleanInput source="accompaniment" className={'colInputContainer'}/>
                        <BooleanInput source="is_bid" className={'colInputContainer'}/>
                        <BooleanInput source="is_caf" className={'colInputContainer'}/>
                        <BooleanInput source="is_fonplata" className={'colInputContainer'}/>
                        <BooleanInput source="is_anchor" className={'colInputContainer'}/>
                    </FieldGroup>

                    <FieldGroup
                        label="fieldGroups.general"
                        formClassName={this.props.classes.borderBottom}
                        titleColumn={false}
                        flex={false}
                    >
                        {/* A country manager does not choose countries: on create they
                            are preset to the ones they manage, and they are never
                            editable. The server enforces the same rule. */}
                        <div>
                            <FormDataConsumer>
                                {({formData}) => (<SelectArrayInput
                                        source="iirsa_countries"
                                        label={'Paises (*)'}
                                        value={formData?.iirsa_countries}
                                        choices={this.state.countries}
                                        validate={this.req}
                                        className={'colInput'}
                                        disabled={this.countryScope.locked}
                                        defaultValue={
                                            this.countryScope.locked && this.isCreateForm()
                                                ? this.countryScope.countries
                                                : undefined
                                        }
                                    />)}
                            </FormDataConsumer>
                        </div>

                        <SelectInput
                            source="iirsa_scope"
                            choices={this.state.alcancesChoices}
                            validate={this.req}
                            className={'colInput'}
                        />

                        <NestedSelectInput
                            label="Sector"
                            source="iirsa_sector"
                            fstSource="iirsa_sector"
                            sndSource="iirsa_subsector"
                            fstLabel="Sector"
                            sndLabel="Subsector"
                            fstChoices={this.state.sectors}
                            // eslint-disable-next-line react/jsx-no-bind
                            getSndChoices={fstValue => fstValue.subsectors}
                            thrdSource="iirsa_project_type"
                            thrdLabel="Tipo de proyecto"
                            getThrdChoices={sndValue => sndValue.projectTypes}
                            draft={this.isDraft}
                        />
                    </FieldGroup>

                    <FieldGroup
                        label="fieldGroups.projectStatus"
                        formClassName={this.props.classes.borderBottom}
                        titleColumn={false}
                        flex={false}
                    >
                        {/* With a Seguimiento the API derives the etapa and rejects other values. */}
                        <SelectInput
                            source="iirsa_stage"
                            choices={this.state.etapasChoices}
                            validate={this.req}
                            className={'colInput'}
                            disabled={this.hasTracking()}
                            helperText={this.hasTracking() ? 'Determinada por el Seguimiento del proyecto' : undefined}
                        />

                        <SelectInput
                            source="iirsa_status"
                            choices={this.state.estadosChoices}
                            className={'colInput'}
                        />

                        <TextInput
                            source="end_date"
                            label="Fecha de finalización"
                            type="month"
                            className={'colInput'}
                        />

                        <SelectInput
                            source="prioritization"
                            label="Priorización"
                            choices={this.state.priorizacionesChoices}
                            className={'colInput'}
                        />

                        <BooleanInput source="has_ambiental_license" className={'colInputContainer'}/>

                        <SelectInput
                            source="iirsa_studies_state"
                            choices={this.state.estadosEstudiosChoices}
                            className={'colInput'}
                        />

                        <BooleanInput source="studies_finished" className={'colInputContainer'}/>

                        <NumberInput source="studies_amount" className={'colInput'}/>

                        <SelectInput
                            source="iirsa_studies_funder"
                            choices={this.state.financiadoresEstudiosChoices}
                            className={'colInput'}
                        />

                        <div className={'colInputContainer'}>
                            <label style={styles.inputLabel}>Comentarios sobre el estado</label>
                            <RichTextInput source="status_comments" toolbar={toolbarOptions}/>
                        </div>

                        <div className={'colInputContainer'}>
                            <label style={styles.inputLabel}>Comentarios sobre el estado de los estudios</label>
                            <RichTextInput source="studies_status_comments" toolbar={toolbarOptions}/>
                        </div>

                        <div className={'colInputContainer'}>
                            <label style={styles.inputLabel}>Comentarios sobre el financiamiento de los estudios</label>
                            <RichTextInput source="studies_funding_comments" toolbar={toolbarOptions}/>
                        </div>

                    </FieldGroup>

                    <FieldGroup
                        label="fieldGroups.projectFunding"
                        formClassName={this.props.classes.borderBottom}
                        titleColumn={false}
                        flex={false}
                    >
                        <ArrayInput source="iirsa_project_funding">
                            <SimpleFormIterator>
                                <NumberInput source="amount" label="resources.projects.fields.amount"
                                             validate={this.req}/>
                                <SelectInput
                                    source="funder"
                                    choices={this.state.financiadoresEstudiosChoices}
                                    label="resources.projects.fields.iirsa_studies_funder"
                                />
                                <SelectInput
                                    source="funding_status"
                                    choices={this.state.estadosFinanciamientoChoices}
                                    label="resources.projects.fields.iirsa_funding_status"
                                />
                                <SelectInput
                                    source="funding_type"
                                    choices={this.state.tiposFinanciamientoChoices}
                                    label="resources.projects.fields.iirsa_funding_type"
                                />
                            </SimpleFormIterator>
                        </ArrayInput>

                        <div className={'colInputContainer'}>
                            <label style={styles.inputLabel}>Comentarios sobre el financiamiento</label>
                            <RichTextInput source="funding_comments" toolbar={toolbarOptions}/>
                        </div>
                    </FieldGroup>

                    <FieldGroup
                        label="fieldGroups.dynamicMap"
                        formClassName={this.props.classes.borderBottom}
                        titleColumn={false}>

                        <FileInput label={'Mapa (.kml, .kmz, .geojson)'} source="kml"
                                   accept={[".kml", ".kmz", ".geojson"]}>
                            <FileLinkField/>
                        </FileInput>

                        <NumberInput source="dynamic_center_latitude" defaultValue={1}
                                     validate={this.reqMap("Debe posicionar el mapa dinámico")}/>
                        <NumberInput source="dynamic_center_longitude" defaultValue={1}
                                     validate={this.reqMap("Debe posicionar el mapa dinámico")}/>
                        <NumberInput source="dynamic_map_zoom" defaultValue={1}
                                     validate={this.reqMap("Debe posicionar el mapa dinámico")}/>

                        <div style={{margin: 'auto'}}>
                            <FormDataConsumer>
                                {({formData}) => (formData && formData.kml) ? <>
                                    <h3>Ajustar mapa</h3>
                                    <DynamicMap
                                        kml={formData.kml}
                                        centerLat={formData.dynamic_center_latitude}
                                        centerLng={formData.dynamic_center_longitude}
                                        zoom={formData.dynamic_map_zoom}
                                        change={this.props.change}
                                        dynamic={true}
                                    />
                                </> : <></>}
                            </FormDataConsumer>
                        </div>
                    </FieldGroup>

                    <FieldGroup
                        label="fieldGroups.staticMap"
                        formClassName={this.props.classes.borderBottom}
                        titleColumn={false}>

                        <FileInput label={'Mapa simplificado (.kml, .kmz, .geojson)'} source="kml_simplified"
                                   accept={[".kml", ".kmz", ".geojson"]}>
                            <FileLinkField/>
                        </FileInput>

                        <NumberInput source="static_center_latitude" defaultValue={1}
                                     validate={this.reqMap("Debe posicionar el mapa estático")}/>
                        <NumberInput source="static_center_longitude" defaultValue={1}
                                     validate={this.reqMap("Debe posicionar el mapa estático")}/>
                        <NumberInput source="static_map_zoom" defaultValue={1}
                                     validate={this.reqMap("Debe posicionar el mapa estático")}/>

                        <div style={{margin: 'auto'}}>
                            <FormDataConsumer>
                                {({formData}) => (formData && formData.kml_simplified) ? <>
                                    <h3>Ajustar mapa</h3>
                                    <DynamicMap
                                        kml={formData.kml_simplified}
                                        centerLat={formData.static_center_latitude}
                                        centerLng={formData.static_center_longitude}
                                        zoom={formData.static_map_zoom}
                                        change={this.props.change}
                                        dynamic={false}
                                    />
                                </> : <></>}
                            </FormDataConsumer>
                        </div>
                    </FieldGroup>

                    {/* <FieldGroup
            label="fieldGroups.dynamicMap"
            formClassName={this.props.classes.borderBottom}
            titleColumn={false}
          >
            <FileInput source="kml" accept=".kml">
              <FileLinkField />
            </FileInput>

            <NumberInput source="dynamic_map_latitude" defaultValue={1} />
            <NumberInput source="dynamic_map_longitude" defaultValue={1} />
            <NumberInput source="dynamic_map_zoom" defaultValue={1} />

            <div style={{ margin: 'auto' }}>
              <FormDataConsumer>
                {({ formData }) =>
                  formData && formData.kml ? (
                    <>
                      <h3>Ajustar mapa</h3>
                      <DynamicMap
                        kml={formData.kml}
                        centerLat={formData.dynamic_map_latitude}
                        centerLng={formData.dynamic_map_longitude}
                        zoom={formData.dynamic_map_zoom}
                        change={this.props.change}
                        dynamic={true}
                      />
                    </>
                  ) : (
                    <></>
                  )
                }
              </FormDataConsumer>
            </div>

            <br />

            <div style={styles.dynamicPreviewBtn}>
              <FormDataConsumer>
                {({ formData }) =>
                  formData && formData.kml ? (
                    <>
                      <ModalMapPreview formData={formData} />
                    </>
                  ) : (
                    <></>
                  )
                }
              </FormDataConsumer>
            </div>
          </FieldGroup> */}

                    <FieldGroup
                        label="fieldGroups.projectSections"
                        formClassName={this.props.classes.borderBottom}
                        titleColumn={false}
                        flex={false}
                    >
                        <ArrayInput source="iirsa_segments">
                            <SimpleFormIterator>
                                <TextInput source="segment" label="resources.projects.fields.name"
                                           validate={this.req}/>
                                <LongTextInput source="description" label="resources.projects.fields.description"/>
                                <SelectInput
                                    source="iirsa_stage"
                                    choices={this.state.etapasChoices}
                                    label="resources.projects.fields.stage"
                                />
                                <NumberInput source="investment" label="resources.projects.fields.investment"/>
                                <NumberInput source="segment_number" formClassName={this.props.classes.hiddenField}/>
                            </SimpleFormIterator>
                        </ArrayInput>
                    </FieldGroup>

                    <FieldGroup label="fieldGroups.galleryItems" formClassName={this.props.classes.borderBottom}>
                        <FormDataConsumer>
                            {({formData}) => {
                                return (<GalleryItemsInput
                                    value={formData.gallery_items}
                                    change={this.props.change}/>);
                            }}
                        </FormDataConsumer>
                    </FieldGroup>
                </SimpleForm>
            </>);
    }
}

const mapDispatchToProps = {change, submit};

IirsaProjectForm.propTypes = {
    classes: PropTypes.shape({
        borderBottom: PropTypes.string.isRequired,
        hiddenField: PropTypes.string.isRequired,
        formCol: PropTypes.string.isRequired
    })
};

export default withRouter(withStyles(styles)(connect(state => ({}), mapDispatchToProps)(translate(IirsaProjectForm))));
